import React, { useState } from "react";
import "./first_time_login.css";

// import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import logo from "../../images/PPKM_Head.png";
import { useNavigate } from "react-router-dom";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import EmailIcon from "@mui/icons-material/Email";
import LockIcon from "@mui/icons-material/Lock";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { IconButton } from "@mui/material";
import HelpIcon from "@mui/icons-material/Help";

const FirstTimeLogin = () => {
  const navigate = useNavigate();

  return (
    <div className="ft-login-page">
      <div className="ft-login-container">
        <div className="ft-login-wrapper">
          <div className="ft-login-title">
            <img className="ft-logo" src={logo} alt="Logo" />
          </div>
          {/* <p className="title_para">PPKM </p>
          <p className="title_para2">Malaysia Shopping Malls Association</p> */}
          <p className="title_para3">Welcome to PPKM Membership System</p>

          <form action="#">
            <label className="ft-input-label">Enter your Member ID:</label>
            <div className="ft-login-input-row">
              <AccountCircleIcon className="ft-login-form-logo" />
              <input className="col-md-9" placeholder="Member ID" required />
            </div>
            <label className="ft-input-label">
              Enter your Registered Email Address:
            </label>
            <div className="ft-login-input-row">
              <EmailIcon className="ft-login-form-logo" />
              <input
                className="col-md-9"
                type="email"
                placeholder="Email Address"
                required
              />
            </div>
            <div className="ft-button">
              <div
                className="ft-login-input-row2 button"
                onClick={() => navigate("/otp")}
              >
                <input type="submit" value="Next" />
              </div>
              <div
                className="ft-login-input-row2 button"
                onClick={() => navigate("/login")}
              >
                <input type="submit" value="Back" />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default FirstTimeLogin;
